
import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Link } from "react-router-dom";
import WorkspaceSidebar from "./WorkspaceSidebar";

interface WorkspaceLayoutProps {
  children: ReactNode;
  workspace: "data" | "email" | "analytics";
}

const WorkspaceLayout = ({ children, workspace }: WorkspaceLayoutProps) => {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex min-h-screen w-full">
        <WorkspaceSidebar currentWorkspace={workspace} />

        <div className="flex-1">
          <header className="flex h-14 items-center gap-4 border-b bg-background px-4 lg:px-6">
            <SidebarTrigger />
            <div className="flex-1">
              <Link to="/" className="focus:outline-none">
                <h1 className="text-lg font-semibold">ScoutLink.ai</h1>
              </Link>
            </div>
          </header>
          
          <main className="flex-1 p-4 md:p-6">{children}</main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default WorkspaceLayout;
